import React from 'react';
import styled from 'styled-components';

import QRCode from 'qrcode.react';

export type QrCodeComponentProps = {
  readonly size?: number;
  readonly value: string;
  readonly iconSrc?: string;
  readonly iconSize?: number;
};

export default function QrCode({
  size = 128,
  value,
  iconSrc,
  iconSize = 25
}: QrCodeComponentProps) {
  // Increase error tolerance with icon size
  // because excavation removes data.
  let level: 'L' | 'M' | 'H' = 'L';
  if (iconSrc) {
    if (iconSize > 15) {
      if (iconSize > 20) {
        level = 'H';
      } else {
        level = 'M';
      }
    }
  }

  return (
    <QrCodeContainer>
      <QRCode
        size={size}
        value={value}
        {...(iconSrc
          ? {
              level: level,
              imageSettings: {
                src: iconSrc,
                height: iconSize,
                width: iconSize,
                excavate: true
              }
            }
          : {})}
      />
    </QrCodeContainer>
  );
}

const QrCodeContainer = styled.div`
  margin: 10px 10px;
  display: flex;
`;
